export default {
  metaTitle: {
    id: 'us_telco_comparators_landing_page_meta_title',
    defaultMessage: 'Compare US Telco Plans | Back Market',
  },
  title: {
    id: 'us_telco_comparators_landing_page_title',
    defaultMessage: 'Great plans, great savings',
  },
  subtitle: {
    id: 'us_telco_comparators_landing_page_subtitle',
    defaultMessage:
      "Every plan gets you premium, flexible coverage on America's most trusted networks.",
  },
  seePlanComparison: {
    id: 'us_telco_comparators_landing_page_see_plan_comparison',
    defaultMessage: 'See plan comparison',
  },
}
